import React from "react";
import PropTypes from "prop-types";
import styles from "./calculator.module.scss";
import webStyles from "../../features/calculator/calculatorWeb.module.scss";

const CalculatorTemplate = ({ 
  title,
  description, 
  formulaSection,
  panel, 
  results, 
  footer,
  isWebLayout = false 
}) => {
  if (isWebLayout) {
    return (
      <div className={webStyles.webLayout}>
        <div className={webStyles.webDescription}>
          {title && (
            <h1 className={webStyles.webDescriptionTitle}>{title}</h1>
          )}
          <div className={webStyles.webDescriptionContent}>
            {description && (
              <div className={webStyles.webInfoBlock}>{description}</div>
            )}
            {formulaSection && (
              <div className={webStyles.webFormulaBlock}>{formulaSection}</div>
            )}
          </div>
        </div>
        
        <div className={webStyles.webCalculator}>
          {panel}
          {results}
          {footer && <div className={styles.footer}>{footer}</div>}
        </div>
      </div>
    );
  }

  // Original app layout
  return (
    <div className={styles.root}>
      <div className={styles.topBlock}>
        {description}
        {formulaSection}
      </div>
      {panel}
      {results}
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

CalculatorTemplate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  formulaSection: PropTypes.node,
  panel: PropTypes.node.isRequired,
  results: PropTypes.node.isRequired,
  footer: PropTypes.node,
  isWebLayout: PropTypes.bool,
};

export default CalculatorTemplate;
